import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class GetDownloadResourceListModel {

    private useremail: string = "";
    private searchkeywords: string = "";
    private searchcategory: string = "";

    constructor() { }

    setUseremail(useremail: string) {
        this.useremail = useremail;
    }

    getUseremail(): string {
        return this.useremail;
    }

    setSearchkeywords(searchkeywords: string) {
        this.searchkeywords = searchkeywords;
    }

    getSearchkeywords(): string {
        return this.searchkeywords;
    }

    setSearchcategory(searchcategory: string) {
        this.searchcategory = searchcategory;
    }

    getSearchcategory(): string {
        return this.searchcategory;
    }

    toString() {
        return JSON.stringify({
            useremail: this.getUseremail(),
            searchkeywords: this.getSearchkeywords(),
            searchcategory: this.getSearchcategory()
        });
    }

}